// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"61d3a227","498":"c3ef9ae5","703":"a2fc32a1","787":"34209f15"}[chunkId] + ".chunk.js";
};